module.exports = __webpack_public_path__ + "static/media/coi.5e379d72.svg";